

















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MissionRightIcon',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
})
